import React from "react";
import { Container, Button, Row, Col, Card } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import "./customproduct.scss";
import { useNavigate } from "react-router-dom";

function CustomProduct() {
  const navigate = useNavigate();

  return (
    <section className="custom-product-section">
      <Container className="py-5">

        {/* Section Title */}
        <div className="text-center mb-5">
          <h2 className="section-title">Customization Products</h2>
          <p className="section-subtitle">
            Tailor-made digital solutions designed to meet your unique business needs.
          </p>
        </div>

        <Row className="g-4">

          {/* Product 1 */}
          <Col md={6}>
            <Card className="custom-card">
              <img
                src="/images/uiplus-services.png"
                alt="Static & Dynamic Website"
                className="card-img-top"
              />

              <Card.Body>
                <h4>Static / Dynamic Website</h4>

                <p style={{textAlign:'justify'}}>
                  We design and develop responsive, SEO-friendly static and dynamic
                  websites tailored to your brand and business requirements.
                </p>

                <ul className="feature-list">
                  <li><CheckCircleFill /> Responsive Design</li>
                  <li><CheckCircleFill /> SEO Optimized</li>
                  <li><CheckCircleFill /> CMS Integration</li>
                  <li><CheckCircleFill /> Secure Hosting Support</li>
                </ul>

                <div className="mt-3">
                  <a href="/contact" className="btn-connect">
                    Call to Connect
                  </a>

                  <a
                    href="/products/website-management"
                    className="more-details ms-3"
                  >
                    More Details →
                  </a>
                  
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Product 2 */}
          <Col md={6}>
            <Card className="custom-card">
              <img
                src="/images/uiplus-services.png"
                alt="Custom Application"
                className="card-img-top"
              />

              <Card.Body>
                <h4>Custom Application</h4>

                <p style={{textAlign:'justify'}}>
                  We build scalable and secure custom software solutions
                  including ERP, CRM, and enterprise-level applications.
                </p>

                <ul className="feature-list">
                  <li><CheckCircleFill /> ERP & CRM Solutions</li>
                  <li><CheckCircleFill /> Cloud Integration</li>
                  <li><CheckCircleFill /> API Development</li>
                  <li><CheckCircleFill /> Maintenance & Support</li>
                </ul>

                <div className="mt-3">
                  <a href="/contact" className="btn-connect">
                    Call to Connect
                  </a>

                  <a
                    href="/products/custom-application"
                    className="more-details ms-3"
                  >
                    More Details →
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>

        </Row>

      </Container>
    </section>
  );
}

export default CustomProduct;
